<template>
  <div>
    <div class="album">
      <div class="album_box" v-for="board in boardData" :key="`album${board.wr_id}`" @click="goDetail(board.wr_id)">
        <div class="album_box_img" :style="`background-image:url(${returnImage(board)})`"></div>
        <div class="album_box_title">{{ board.wr_subject }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BoardListAlbumLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      if (!util.isEmpty(board.File.MobileFile[0])) {
        return `${board.File.MobileFile[0].org_url}?${this.setImageOptions(316, 316, 'jpg')}`;
      }
    },
    goDetail(idx) {
      this.$router.push(`/album/${idx}`)
    },

  },
  watch: {},
}
</script>

<style scoped>
.test {
  width: 100px;
  height: 100px;
}
</style>